export const RECEIVED_FLAGS = "RECEIVED_FLAGS";
export const CREATED_FLAG = "CREATED_FLAG";
export const DELETED_FLAG = "DELETED_FLAG";
export const CLEARED_FLAGS_USER_DATA = "CLEARED_FLAGS_USER_DATA";
